export const ETM_TICKETS_TRIP_LIST = 'etm-tickets-trip-list'
export const ETM_TICKET_DETAILS = 'etm-ticket-details'
export const CLEAR_TICKET_DETAILS = 'clear-tickets-details'
export const CLEAR_ALL_ETM_TICKETS_DATA = 'clear-all-etm-tickets-data'
export const UPDATE_ETM_USER_INPUT_VALUES = 'update-etm-user-input-values'
export const ETM_ROUTES_LIST = 'etm-routes'
